// extracted by mini-css-extract-plugin
export default {"search-item":"ItemSearch_search-item__Ua8hr"};